import { render, staticRenderFns } from "./PurchasingReturnForm.vue?vue&type=template&id=3bc8ff56"
import script from "./PurchasingReturnForm.vue?vue&type=script&lang=js"
export * from "./PurchasingReturnForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports